export default __webpack_public_path__ + "static/media/Blanched Vambraces.00dc66a7.jpg";